import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  DeleteBookingMutationMutation,
  DeleteBookingMutationMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';
import { BOOKING_LIST_GET_BOOKINGS } from './useGetBookings';

export const DELETE_BOOKING = graphql(`
  mutation DeleteBookingMutation($bookingId: Int!) {
    deleteBooking(bookingId: $bookingId) {
      deletedBookingId
    }
  }
`);

export const useDeleteBooking = () => {
  const [deleteBookingMutation, { error: mutationError, loading: mutationLoading, data }] =
    useMutation<DeleteBookingMutationMutation, DeleteBookingMutationMutationVariables>(
      DELETE_BOOKING,
    );

  const deleteBooking = useCallback(
    async (bookingId?: number) => {
      if (!bookingId) return;

      await deleteBookingMutation({
        variables: { bookingId },
        refetchQueries: [BOOKING_LIST_GET_BOOKINGS],
      });
    },
    [deleteBookingMutation],
  );

  return {
    deleteBooking,
    deleteBookingLoading: mutationLoading,
    deleteBookingError: mutationError,
    deleteBookingData: data,
  };
};
